import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api'

export interface SapItemSearchResult {
  ItemCode: string
  ItemName: string
  SalesPrice: number
  PurchasePrice: number
}

/**
 * Shared SAP item-search hook used by TicketDetailPage and QuotationViewPage.
 * Same `queryKey` so React-Query dedupes the request when both are mounted.
 */
export function useSapItemSearch(query: string, opts?: { enabled?: boolean }) {
  return useQuery<SapItemSearchResult[]>({
    queryKey: ['sap', 'items', query],
    queryFn: () => apiClient.get('/sap/items/search', { params: { q: query } }).then((r) => r.data),
    enabled: (opts?.enabled ?? true) && query.length >= 2,
    staleTime: 10_000,
  })
}
